import { Modal, Stack, SegmentedControl, Slider, Text, Group, Button, Paper } from '@mantine/core';
import { IconSun, IconMoon, IconDeviceDesktop } from '@tabler/icons-react';
import { useSettings } from '../../store/settings';

export default function UserSettingsModal({ onClose }: { onClose: () => void }) {
  const { theme, fontScale, setTheme, setFontScale } = useSettings();

  return (
    <Modal opened onClose={onClose} title={<span className="modal-title-custom">User Settings</span>} size="md">
      <Stack>
        <div className="section">
          <div className="section-header">Theme</div>
          <div className="section-body">
            <SegmentedControl
              fullWidth
              value={theme}
              onChange={(v) => setTheme(v as any)}
              data={[
                { value: 'light', label: (<Group gap={4} justify="center"><IconSun size={14} /> Light</Group>) as any },
                { value: 'dark',  label: (<Group gap={4} justify="center"><IconMoon size={14} /> Dark</Group>) as any },
                { value: 'auto',  label: (<Group gap={4} justify="center"><IconDeviceDesktop size={14} /> Auto</Group>) as any },
              ]}
            />
            <Text size="xs" c="dimmed">Changes the color scheme across the entire application. "Auto" follows your OS preference.</Text>
          </div>
        </div>

        <div className="section">
          <div className="section-header">Font Size</div>
          <div className="section-body">
            <Group justify="space-between" mb={6}>
              <Text size="sm" fw={500}>Scale</Text>
              <Text size="sm" c="orange" fw={600}>{Math.round(fontScale * 100)}%</Text>
            </Group>
            <Slider
              min={0.75} max={2} step={0.05}
              value={fontScale}
              onChange={setFontScale}
              marks={[
                { value: 0.75, label: '75%' },
                { value: 1.0, label: '100%' },
                { value: 1.5, label: '150%' },
                { value: 2.0, label: '200%' },
              ]}
              color="orange"
            />
            <Paper withBorder p="sm" mt="md" style={{ background: 'var(--mantine-color-body)' }}>
              <Text size="xs" c="dimmed" mb={4}>Preview</Text>
              <Text>The quick brown fox jumps over the lazy dog.</Text>
              <Text size="sm">Affects every text element in the app.</Text>
            </Paper>
            <Group justify="flex-end" mt="sm">
              <Button size="xs" variant="subtle" onClick={() => setFontScale(1)}>Reset to 100%</Button>
            </Group>
          </div>
        </div>

        <Group justify="flex-end" mt="md">
          <Button onClick={onClose}>Done</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
